var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5572 10.2054C16.9476 9.81475 16.9474 9.18159 16.5567 8.79119C16.1661 8.4008 15.5329 8.40101 15.1425 8.79166L16.5572 10.2054ZM10.8501 14.5016L10.143 15.2087C10.3306 15.3963 10.585 15.5016 10.8503 15.5016C11.1156 15.5015 11.37 15.3961 11.5575 15.2085L10.8501 14.5016ZM8.85725 11.0945C8.46673 10.704 7.83356 10.704 7.44304 11.0945C7.05252 11.485 7.05252 12.1182 7.44304 12.5087L8.85725 11.0945ZM15.1425 8.79166L10.1428 13.7947L11.5575 15.2085L16.5572 10.2054L15.1425 8.79166ZM11.5573 13.7945L8.85725 11.0945L7.44304 12.5087L10.143 15.2087L11.5573 13.7945Z",
    fill: "#33D713"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircleWhite);
export default __webpack_public_path__ + "static/media/icon-Check-Circle-White.43a8454a5f33a1d70666163b10e29224.svg";
export { ForwardRef as ReactComponent };